import React from 'react'

const IconVisualizerOne = ({ width = '24', height = '24' }) => (
  <svg
    viewBox={`0 0 ${width} ${height}`}
    width={`${width}px`}
    height={`${height}px`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
      <path
        d="M12,10 C14.209139,10 16,11.790861 16,14 C16,15.0647454 15.5839866,16.0323256 14.905636,16.7490645 C16.6892551,17.7381734 17.91607,19.610125 17.9958615,21.7750617 L18,22 L6,22 L6.00413847,21.7750617 C6.08393,19.610125 7.31074494,17.7381734 9.09478152,16.7490089 C8.41601341,16.0323256 8,15.0647454 8,14 C8,11.790861 9.790861,10 12,10 Z M12,18 C10.5976787,18 9.35991367,18.7232685 8.64568166,19.8097769 L8.528,20 L15.464,20 L15.3707485,19.8449536 C14.6927317,18.7871583 13.53039,18.0707839 12.2006732,18.0049564 L12,18 Z M12,12 C10.8954305,12 10,12.8954305 10,14 C10,15.1045695 10.8954305,16 12,16 C13.1045695,16 14,15.1045695 14,14 C14,12.8954305 13.1045695,12 12,12 Z M23,2 L23,15 L17.9169061,15.0008069 C17.9715542,14.6753441 18,14.340994 18,14 C18,13.6593547 17.9716124,13.3253396 17.9170737,13.0001915 L21,13 L21,4 L3,4 L3,13 L6.08292631,13.0001915 C6.02838765,13.3253396 6,13.6593547 6,14 C6,14.340994 6.02844579,14.6753441 6.08309386,15.0008069 L1,15 L1,2 L23,2 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconVisualizerOne
